import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-dark.png'
import _imports_1 from '@/assets/images/logo-light.png'


const _withScopeId = n => (_pushScopeId("data-v-3a384c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-menu" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "center-menu" }
const _hoisted_9 = { class: "navigation-viewport" }
const _hoisted_10 = { class: "navigation-items" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "icons"
}
const _hoisted_13 = {
  key: 0,
  class: "icon",
  style: {"margin-bottom":"5px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px"} }, "客服", -1))
const _hoisted_15 = {
  key: 0,
  class: "qr-code"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"rgba(0,0,0,0.8)","text-align":"center","padding":"5px 0"} }, "客服二维码", -1))
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "qr-code"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"rgba(0,0,0,0.8)","text-align":"center","padding":"5px 0"} }, "客服二维码", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/customerServices.png",
  alt: ""
}, null, -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "qr-code service-unavailable"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px"} }, "小程序", -1))
const _hoisted_24 = { class: "qr-code" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"rgba(0,0,0,0.8)","text-align":"center","padding":"5px 0"} }, "扫码查看小程序", -1))
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "right-menu" }
const _hoisted_28 = { class: "wrapper" }
const _hoisted_29 = ["aria-label", "aria-expanded"]
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 蓝迪云 ", -1))
const _hoisted_32 = { class: "item" }
const _hoisted_33 = { class: "item" }
const _hoisted_34 = {
  class: "item",
  style: {"width":"100%","text-align":"left"}
}
const _hoisted_35 = { class: "item" }
const _hoisted_36 = { class: "item center regnow" }
const _hoisted_37 = { class: "item center regnow" }
const _hoisted_38 = { class: "item" }
const _hoisted_39 = { class: "item" }
const _hoisted_40 = {
  key: 0,
  class: "password-note"
}
const _hoisted_41 = { class: "item" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 1,
  style: {"cursor":"not-allowed","user-select":"none","color":"red"}
}
const _hoisted_44 = { class: "item" }
const _hoisted_45 = { class: "item" }
const _hoisted_46 = { class: "item" }
const _hoisted_47 = { class: "item" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  style: {"cursor":"not-allowed","user-select":"none","color":"red"}
}
const _hoisted_50 = {
  class: "item",
  style: {"width":"100%","text-align":"left"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item sms-registration-note" }, "未注册的手机号验证后将自动注册为普通用户，账号归属当前平台或分店。", -1))
const _hoisted_52 = { class: "item sms-registration-terms" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/userArgument",
  target: "_blank",
  rel: "noopener noreferrer"
}, "《注册使用条款》", -1))
const _hoisted_54 = { class: "item" }
const _hoisted_55 = { class: "item center regnow" }
const _hoisted_56 = {
  key: 1,
  class: "phone-binding"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"font-size":"18px"}
}, "绑定手机号", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("div", null, "当前您的帐号未绑定手机号为了保障您的权益,"),
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","font-weight":"bold"} }, "请务必绑定手机号")
], -1))
const _hoisted_59 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "/userArgument",
  style: {"width":"750px","height":"400px"},
  frameborder: "0"
}, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "我已认真阅读会员条款,并同意该条款内容", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","font-size":"25px","margin":"20px"} }, "新用户注册", -1))
const _hoisted_63 = { style: {"text-align":"center","cursor":"pointer","margin-top":"20px"} }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您确定要退出登录吗？", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您有新的优惠券，请前往优惠券详情页查看。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileNavigation = _resolveComponent("MobileNavigation")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_SelectTheam = _resolveComponent("SelectTheam")!
  const _component_Language = _resolveComponent("Language")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_key_outlined = _resolveComponent("key-outlined")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_mobile_outlined = _resolveComponent("mobile-outlined")!
  const _component_mail_outlined = _resolveComponent("mail-outlined")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_wxlogin = _resolveComponent("wxlogin")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['navbar',_ctx.path==='/main/index'?'navbar-background':''])
  }, [
    _createVNode(_component_MobileNavigation, {
      menus: _ctx.menus.filter(menu=>menu.path!=='/main/helpcenter' || _ctx.helpCenterVisible),
      title: _ctx.orgInfo.orgShortName,
      logo: _ctx.orgInfo.logoUrl1 || _ctx.orgInfo.logoUrl,
      "logged-in": _ctx.logined,
      "personal-visible": _ctx.clientFunctionVisible('个人中心'),
      "scale-visible": _ctx.clientFunctionVisible('智能量体'),
      "recharge-visible": _ctx.rechargeVisible,
      "member-visible": _ctx.logined && (_ctx.orgId===1000 || _ctx.clientFunctionVisible('会员级别管理')),
      "member-title": _ctx.orgId===1000?'购买会员':'入驻加盟',
      "service-visible": _ctx.clientFunctionVisible('售后服务'),
      "service-url": _ctx.orgInfo.customerServiceUrl || '',
      "service-phone": _ctx.orgInfo.cellPhone || '',
      platform: _ctx.orgId===1000,
      onNavigate: _cache[0] || (_cache[0] = menu=>_ctx.menuclick(menu,_ctx.menus.indexOf(menu))),
      onPersonal: _ctx.mobilePersonal,
      onSecurity: _ctx.securityNotifications,
      onLogin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLoginForm=true)),
      onRecharge: _ctx.rechargeOffers,
      onScale: _ctx.scaleClick,
      onMember: _ctx.myspace,
      onPassword: _ctx.showupdatePwd,
      onLogout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmExit=true))
    }, null, 8, ["menus", "title", "logo", "logged-in", "personal-visible", "scale-visible", "recharge-visible", "member-visible", "member-title", "service-visible", "service-url", "service-phone", "platform", "onPersonal", "onSecurity", "onRecharge", "onScale", "onMember", "onPassword"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.orgInfo.logoUrl && _ctx.orgId!==1000)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ((_ctx.path==='/main/index' && _ctx.scrolltop<50))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.orgInfo.logoUrl,
                  alt: ""
                }, null, 8, _hoisted_2))
              : (_ctx.orgInfo.logoUrl1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.orgInfo.logoUrl1,
                    alt: ""
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("img", _hoisted_4))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ((_ctx.path==='/main/index' && _ctx.scrolltop<50))
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6))
          ], 64)),
      _createElementVNode("div", {
        class: "logo-title",
        title: _ctx.orgInfo.orgShortName
      }, _toDisplayString(_ctx.orgInfo.orgShortName), 9, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationMenus, (menu) => {
            return (_openBlock(), _createElementBlock("div", {
              key: menu.path,
              onClick: ($event: any) => (_ctx.menuclick(menu, _ctx.menus.indexOf(menu))),
              class: _normalizeClass([_ctx.selectedIndex === _ctx.menus.indexOf(menu) && _ctx.selectedIndex>0 ? 'selected' : ''])
            }, _toDisplayString(menu.title), 11, _hoisted_11))
          }), 128))
        ])
      ])
    ]),
    (_ctx.detailRechargeVisible)
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          class: "detail-stored-value-offer",
          type: "primary",
          onClick: _ctx.rechargeOffers
        }, {
          default: _withCtx(() => [
            _createTextVNode("储值优惠")
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.showApp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_ctx.clientFunctionVisible('售后服务'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createVNode(_component_svg_icon, { icon: "contactus" })
                ]),
                _hoisted_14,
                (_ctx.orgInfo.customerServiceUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      (_ctx.orgInfo.customerServiceUrl.includes('https'))
                        ? (_openBlock(), _createBlock(_component_qrcode_vue, {
                            key: 0,
                            color: { dark: '#000000', light: '#ffffff' },
                            type: "image/png",
                            value: _ctx.orgInfo.customerServiceUrl,
                            size: 300
                          }, null, 8, ["value"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.orgInfo.customerServiceUrl,
                            alt: ""
                          }, null, 8, _hoisted_17))
                    ]))
                  : (_ctx.orgId==1000)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, "暂未开通在线客服，请拨打客服电话"))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "close",
            onClick: _cache[3] || (_cache[3] = ()=>{_ctx.showApp=false})
          }, [
            _createVNode(_component_svg_icon, { icon: "close" })
          ]),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadIcon && _ctx.downloadIcon(...args))),
            class: "icon",
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_svg_icon, { icon: "applet" })
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("img", {
                src: _ctx.appletQrcode,
                alt: ""
              }, null, 8, _hoisted_26)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      (_ctx.previliges['智能量体'] || _ctx.vipVisibleFunctions['智能量体'])
        ? (_openBlock(), _createBlock(_component_a_popover, { key: 0 }, {
            content: _withCtx(() => [
              _createTextVNode(" 智能量体 ")
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_svg_icon, {
                  onClick: _ctx.scaleClick,
                  style: {"font-size":"30px"},
                  icon: "scales"
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_SelectTheam),
      _createVNode(_component_Language),
      (_ctx.logined)
        ? (_openBlock(), _createBlock(_component_a_popover, {
            key: 1,
            visible: _ctx.accountMenuVisible,
            "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.accountMenuVisible) = $event)),
            trigger: "click",
            placement: "bottomRight"
          }, {
            title: _withCtx(() => [
              (_ctx.clientFunctionVisible('个人中心'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "account-menu-item",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.accountMenuVisible=false; _ctx.viewAccount()})
                  }, "账户信息"))
                : _createCommentVNode("", true)
            ]),
            content: _withCtx(() => [
              (_ctx.clientFunctionVisible('意见反馈'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "account-menu-item",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.accountMenuVisible=false; _ctx.suggest()})
                  }, "聆听建议"))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "account-menu-item",
                onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.accountMenuVisible=false; _ctx.securityNotifications()})
              }, "系统通知"),
              _createElementVNode("div", {
                class: "account-menu-item",
                onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.accountMenuVisible=false; _ctx.showupdatePwd()})
              }, "修改密码"),
              _createElementVNode("div", {
                class: "account-menu-item",
                onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.accountMenuVisible=false; _ctx.confirmExit=true})
              }, "退出登录")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_tooltip, {
                title: _ctx.clientFunctionVisible('个人中心')?'个人中心':'账户菜单',
                "mouse-enter-delay": 0.1
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "avatar-logo",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.avatarPersonal && _ctx.avatarPersonal(...args))),
                    "aria-label": _ctx.clientFunctionVisible('个人中心')?'个人中心与账户菜单':'账户菜单',
                    "aria-expanded": _ctx.accountMenuVisible
                  }, [
                    (_ctx.userInfo.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.userInfo.avatar+'?x-oss-process=image/resize,h_200,m_lfit',
                          alt: ""
                        }, null, 8, _hoisted_30))
                      : (_openBlock(), _createBlock(_component_svg_icon, {
                          key: 1,
                          icon: "person"
                        }))
                  ], 8, _hoisted_29)
                ]),
                _: 1
              }, 8, ["title", "mouse-enter-delay"])
            ]),
            _: 1
          }, 8, ["visible"]))
        : _createCommentVNode("", true),
      (!_ctx.logined)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 2,
            onClick: _cache[12] || (_cache[12] = ()=>{_ctx.showLoginForm=true}),
            shape: "round",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("登录/注册")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.open,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.open) = $event)),
      title: _ctx.isForeceReset?'首次登录，请为您的账户设置一个登录密码':'修改密码'
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.updatePwd
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: _cache[16] || (_cache[16] = ()=>{_ctx.open=false})
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formInfo",
          model: _ctx.accountInfo,
          name: "basic",
          "label-col": {style: { width: '110px' }},
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "用户登录名:" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  readonly: "",
                  value: _ctx.accountInfo.username,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.accountInfo.username) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            (!_ctx.isForeceReset)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "原始密码:",
                  name: "password",
                  rules: [{ required: true, message: '请录入正确的原始密码!' }  ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: _ctx.accountInfo.password,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.accountInfo.password) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "新密码:",
              name: "newPassword",
              rules: [{validator: _ctx.validatePassword, trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.accountInfo.newPassword,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.accountInfo.newPassword) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showLoginForm,
      "onUpdate:visible": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.showLoginForm) = $event)),
      title: "",
      width: 400
    }, {
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['account-login',!_ctx.isWxLogin?'account-login-show':''])
        }, [
          _hoisted_31,
          _createVNode(_component_a_tabs, {
            onChange: _ctx.keyChanged,
            class: "login-form",
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.activeKey) = $event)),
            centered: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 1,
                tab: "登录名密码登录"
              }, {
                default: _withCtx(() => [
                  (_ctx.islogin)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_a_input, {
                            size: "large",
                            onKeyup: _withKeys(_ctx.loginClick, ["enter"]),
                            placeholder: "登录名/手机号码",
                            value: _ctx.loginInfo.username,
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.loginInfo.username) = $event))
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_user_outlined, { type: "user" })
                            ]),
                            _: 1
                          }, 8, ["onKeyup", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_a_input_password, {
                            onKeyup: _withKeys(_ctx.loginClick, ["enter"]),
                            visibilityToggle: true,
                            size: "large",
                            placeholder: "密码",
                            value: _ctx.loginInfo.password,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.loginInfo.password) = $event))
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_key_outlined)
                            ]),
                            _: 1
                          }, 8, ["onKeyup", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.loginInfo.remebmer,
                            "onUpdate:checked": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.loginInfo.remebmer) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("记住账号")
                            ]),
                            _: 1
                          }, 8, ["checked"]),
                          _createElementVNode("span", {
                            class: "forgotpwd",
                            onClick: _cache[21] || (_cache[21] = ()=>{_ctx.islogin=false})
                          }, "忘记密码")
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_a_button, {
                            size: "large",
                            style: {"width":"100%"},
                            type: "primary",
                            onClick: _ctx.loginClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("登录")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("span", {
                            onClick: _cache[22] || (_cache[22] = ()=>{_ctx.showLoginForm=false; _ctx.showRegForm=true})
                          }, "没有账号？现在注册")
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("span", {
                            onClick: _cache[23] || (_cache[23] = ()=>{_ctx.activeKey=2})
                          }, "不清楚密码？尝试验证码登录")
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_a_input, {
                            status: _ctx.resetPwd.phoneStatus,
                            size: "large",
                            value: _ctx.resetPwd.phone,
                            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.resetPwd.phone) = $event)),
                            placeholder: "输入手机号码"
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_mobile_outlined)
                            ]),
                            _: 1
                          }, 8, ["status", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_a_input_password, {
                            visibilityToggle: true,
                            status: _ctx.resetPwd.newPwdStatus,
                            size: "large",
                            placeholder: "输入新密码",
                            value: _ctx.resetPwd.password,
                            "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.resetPwd.password) = $event))
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_key_outlined)
                            ]),
                            _: 1
                          }, 8, ["status", "value"])
                        ]),
                        (_ctx.pwdError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, "密码规则：至少6位且包含字母与数字，可使用 . 和 !"))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_a_input, {
                            status: _ctx.resetPwd.codeStatus,
                            value: _ctx.resetPwd.code,
                            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.resetPwd.code) = $event)),
                            style: {"width":"180px"},
                            size: "large",
                            placeholder: "输入验证码"
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_mail_outlined)
                            ]),
                            _: 1
                          }, 8, ["status", "value"]),
                          (_ctx.getValidaCodeText=='获取验证码')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.getValidaCode(_ctx.resetPwd.phone)))
                                }, "        " + _toDisplayString(_ctx.getValidaCodeText), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_43, "        " + _toDisplayString(_ctx.getValidaCodeText), 1))
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_a_button, {
                            size: "large",
                            style: {"width":"100%"},
                            type: "primary",
                            onClick: _ctx.resetPwdClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("重置密码")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_a_button, {
                            size: "large",
                            style: {"width":"100%"},
                            onClick: _cache[28] || (_cache[28] = ()=>{_ctx.islogin=true})
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("取消")
                            ]),
                            _: 1
                          })
                        ])
                      ], 64))
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 2,
                tab: "手机验证码登录",
                "force-render": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_a_input, {
                      status: _ctx.codeState.phone,
                      size: "large",
                      value: _ctx.validation.phone,
                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.validation.phone) = $event)),
                      placeholder: "输入手机号码"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_mobile_outlined)
                      ]),
                      _: 1
                    }, 8, ["status", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_a_input, {
                      status: _ctx.codeState.code,
                      value: _ctx.validation.code,
                      "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.validation.code) = $event)),
                      style: {"width":"180px"},
                      size: "large",
                      placeholder: "输入验证码"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_mail_outlined)
                      ]),
                      _: 1
                    }, 8, ["status", "value"]),
                    (_ctx.getValidaCodeText=='获取验证码')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.getValidaCode(_ctx.validation.phone,true)))
                          }, "        " + _toDisplayString(_ctx.getValidaCodeText), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_49, "        " + _toDisplayString(_ctx.getValidaCodeText), 1))
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.loginInfo.remebmer,
                      "onUpdate:checked": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.loginInfo.remebmer) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("记住账号")
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.codeAcceptTerm,
                      "onUpdate:checked": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.codeAcceptTerm) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("我已阅读并同意")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _hoisted_53
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_a_button, {
                      size: "large",
                      style: {"width":"100%"},
                      type: "primary",
                      onClick: _ctx.codeLogin
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("登录/注册")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("span", {
                      onClick: _cache[34] || (_cache[34] = ()=>{_ctx.showLoginForm=false; _ctx.showRegForm=true})
                    }, "没有账号？现在注册")
                  ])
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                style: {"text-align":"center"},
                key: 3,
                tab: "微信扫码登录"
              }, {
                default: _withCtx(() => [
                  (!_ctx.showPhoneBinding)
                    ? (_openBlock(), _createBlock(_component_wxlogin, {
                        key: 0,
                        appid: _ctx.wxloginData.appid,
                        scope: "snsapi_login",
                        state: _ctx.wxLoginstate.orgId+'_C_'+_ctx.wxLoginstate.t,
                        self_redirect: "true",
                        redirect_uri: _ctx.wxloginData.redirectUrl
                      }, null, 8, ["appid", "state", "redirect_uri"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _hoisted_57,
                        _hoisted_58,
                        _createVNode(_component_a_form, {
                          ref: "bindingPhone",
                          style: {"text-align":"left"},
                          model: _ctx.bindingData,
                          name: "basic",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              name: "phone",
                              rules: [{ required: true, message: '请录入11位手机号码' }  ]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  status: _ctx.codeState.regPhone,
                                  placeholder: "请录入手机号码",
                                  value: _ctx.bindingData.phone,
                                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.bindingData.phone) = $event))
                                }, {
                                  prefix: _withCtx(() => [
                                    _createVNode(_component_user_outlined, { type: "user" })
                                  ]),
                                  _: 1
                                }, 8, ["status", "value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, {
                              name: "code",
                              rules: [{ required: true, message: '请录入6位短信验证码' }  ]
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_59, [
                                  _createVNode(_component_a_input, {
                                    style: {"width":"220px"},
                                    status: _ctx.accountExists?'error':'',
                                    placeholder: "请录入6位短信验证码",
                                    value: _ctx.bindingData.code,
                                    "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.bindingData.code) = $event))
                                  }, {
                                    prefix: _withCtx(() => [
                                      _createVNode(_component_mail_outlined, { type: "user" })
                                    ]),
                                    _: 1
                                  }, 8, ["status", "value"]),
                                  _createVNode(_component_a_button, {
                                    disabled: _ctx.bindPhoneButton!='获取验证码',
                                    type: "primary",
                                    onClick: _ctx.sendCode
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.bindPhoneButton), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "onClick"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  style: {"width":"100%"},
                                  onClick: _ctx.bingding,
                                  size: "large",
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("绑定")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["onChange", "activeKey"])
        ], 2)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showRegForm,
      "onUpdate:visible": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.showRegForm) = $event)),
      title: "蓝迪云平台注册使用条款",
      width: 800
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[40] || (_cache[40] = ()=>{_ctx.showRegForm=false})
        }, {
          default: _withCtx(() => [
            _createTextVNode("不同意")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: !_ctx.acceptTerm,
          onClick: _cache[41] || (_cache[41] = ()=>{_ctx.showRegForm=false;_ctx.showRegAccountForm=true})
        }, {
          default: _withCtx(() => [
            _createTextVNode("同意")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _hoisted_60,
        _createVNode(_component_a_checkbox, {
          style: {"margin-top":"10px"},
          checked: _ctx.acceptTerm,
          "onUpdate:checked": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.acceptTerm) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_61
          ]),
          _: 1
        }, 8, ["checked"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showRegAccountForm,
      "onUpdate:visible": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.showRegAccountForm) = $event)),
      width: 350
    }, {
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _hoisted_62,
        _createVNode(_component_a_form, {
          ref: "regAccountFormInfo",
          model: _ctx.newAccountInfo,
          name: "basic",
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { name: "loginName" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  status: _ctx.accountExists?'error':'',
                  placeholder: "登录名（选填，默认手机号）",
                  value: _ctx.newAccountInfo.loginName,
                  "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.newAccountInfo.loginName) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_user_outlined, { type: "user" })
                  ]),
                  _: 1
                }, 8, ["status", "value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "cellphone",
              rules: [{ required: true, message: '请录入联系人手机号码' }  ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "联系人手机号码",
                  status: _ctx.codeState.regPhone,
                  value: _ctx.newAccountInfo.cellphone,
                  "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.newAccountInfo.cellphone) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_mobile_outlined)
                  ]),
                  _: 1
                }, 8, ["status", "value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { name: "nickName" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "姓名（选填）",
                  value: _ctx.newAccountInfo.nickName,
                  "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.newAccountInfo.nickName) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_user_outlined, { type: "user" })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "password",
              rules: [{ validator: _ctx.validatePassword,trigger: 'change', }  ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  placeholder: "请录入密码",
                  value: _ctx.newAccountInfo.password,
                  "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.newAccountInfo.password) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_key_outlined)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              name: "newPassword",
              rules: [{validator: _ctx.retryValidatePassword, trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  placeholder: "请再输入一次登录密码",
                  value: _ctx.newAccountInfo.newPassword,
                  "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.newAccountInfo.newPassword) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_key_outlined)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              name: "validateCode",
              rules: [{required:true,message: '请录入验证码'  }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  style: {"width":"150px"},
                  placeholder: "短信验证码",
                  value: _ctx.newAccountInfo.validateCode,
                  "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.newAccountInfo.validateCode) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_mail_outlined)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createTextVNode("    "),
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.getValidaCodeForReg && _ctx.getValidaCodeForReg(...args)))
                  }, _toDisplayString(_ctx.getValidaCodeText), 1)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_a_button, {
                style: {"width":"300px"},
                onClick: _ctx.regAccount,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定注册")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[50] || (_cache[50] = ()=>{_ctx.showRegAccountForm=false;_ctx.showLoginForm=true})
              }, "已有账号？现在登录")
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.confirmExit,
      "onUpdate:visible": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.confirmExit) = $event)),
      title: "退出登录",
      "ok-text": "确认",
      "cancel-text": "取消",
      onOk: _ctx.logout
    }, {
      default: _withCtx(() => [
        _hoisted_64
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showNewNotes,
      "onUpdate:visible": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.showNewNotes) = $event)),
      title: "您有新的优惠券",
      "ok-text": "查看",
      "cancel-text": "关闭",
      onOk: _ctx.gotoNote
    }, {
      default: _withCtx(() => [
        _hoisted_65
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 2))
}